















































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { Listing, MapSettings, MapMarker, InspectionTime } from 'client-website-ts-library/types';
import { ItemCyclerSlide, ItemCyclerReiszableImageSlide, ItemCyclerEmbeddableSlide } from '@/app_code/ItemCycler';
import { CarouselBreakpoint } from '@/app_code/CarouselBreakpoint';
import { API, Config, Logger, LogLevel } from 'client-website-ts-library/services';
import { EmbeddedContent, EmbeddedContentType } from 'client-website-ts-library/types/EmbeddedContent/EmbeddedContent';
import { FormConstructorData } from 'client-website-ts-library/types/Forms';
import { ContextItemType, CustomContextItem } from 'client-website-ts-library/types/Context';
import { AsyncView, RouteMeta } from 'client-website-ts-library/plugins';

import ItemCycler from '@/components/Cycler/ItemCycler.vue';
import InspectionCard from '@/components/InspectionCard.vue';
import ListingAgentProfile from '@/components/ListingAgentProfile.vue';
import Form from '@/components/Forms/Form.vue';
import { AnalyticsEvent, AnalyticsEventObject, AnalyticsEventType } from 'client-website-ts-library/services/Analytics';
import HomeLoanCalculator from '@/components/Calculators/HomeLoanCalculator.vue';
import { Map } from 'client-website-ts-library/components';

// const Map = () => import('client-website-ts-library/components/Map/Map.vue');

@Component({
  components: {
    ItemCycler,
    InspectionCard,
    Map,
    ListingAgentProfile,
    Form,
    HomeLoanCalculator,
  },
})
export default class ListingDetails extends Mixins(AsyncView) {
  private listing: Listing | null = null;

  private mapSettings?: MapSettings;

  private isMobile = false;

  private cyclerItems: ItemCyclerSlide[] = [];

  private inspectionSelection: InspectionTime | null = null

  private inspectionFormData: FormConstructorData | null = null

  private cyclerBreakpoints: CarouselBreakpoint[] = [
    {
      breakpoint: 0,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
  ];

  private formData: FormConstructorData | null = null;

  private virtualTourShown = false;

  handleInspectionClicked(inspection: InspectionTime) {
    console.log(inspection);

    if (this.inspectionFormData) this.inspectionFormData = null;

    this.$nextTick(() => {
      if (!this.listing) return;

      this.inspectionSelection = inspection;
      this.inspectionFormData = {
        ClientWebsiteId: Config.Website.Id,
        Items: [
          {
            Type: ContextItemType.Listing,
            Id: this.listing.Id,
          },
          ({
            Type: ContextItemType.CustomData,
            Key: 'InspectionTimeStart',
            Value: inspection.StartDate.toString(),
          } as CustomContextItem),
        ],
      };
    });
  }

  created() {
    API.Listings.Get(this.$route.params.id).then((listing) => {
      this.listing = listing;

      this.formData = new FormConstructorData([
        {
          Type: ContextItemType.Listing,
          Id: this.listing.Id,
        },
      ]);

      this.cyclerItems = listing.Images.map((img) => new ItemCyclerReiszableImageSlide(img));

      listing.EmbeddedContent.forEach((item) => {
        if (item.Type === EmbeddedContentType.Youtube || item.Type === EmbeddedContentType.Vimeo) {
          this.cyclerItems.splice(1, 0, new ItemCyclerEmbeddableSlide(item));
        }
      });

      if (listing.Address.DisplayAddress) {
        this.mapSettings = new MapSettings({
          Markers: [
            new MapMarker({
              Coordinate: listing.Address.Coordinates,
              Title: listing.Address.MicroAddress,
            }),
          ],
        });
      }

      this.$emit('updateView');

      if (window.location.hash === '#virtualtour' && this.virtualTour != null) {
        this.virtualTourShown = true;
      }
    }).catch(() => {
      Logger.Log(LogLevel.Error, 'Failed to load listing');
    });
  }

  get isCurrent(): boolean {
    return this.listing!.Status === 'Current' || this.listing!.Status === 'Under Contract';
  }

  get isSale(): boolean {
    return this.listing!.MethodOfSale === 'Sale' || this.listing!.MethodOfSale === 'For Sale' || this.listing!.MethodOfSale === 'Auction';
  }

  get formattedAddressLine1(): string {
    const parts = [];

    if (this.listing === null) return '';

    if (this.listing.Address.UnitNumber) {
      parts.push(`${this.listing.Address.UnitNumber} / ${this.listing.Address.StreetNumber}`);
    } else {
      parts.push(this.listing.Address.StreetNumber);
    }

    parts.push(this.listing.Address.Address);

    return parts.join(' ');
  }

  get formattedAddressLine2(): string {
    if (this.listing === null) return '';

    return `${this.listing.Address.Suburb}, ${this.listing.Address.State} ${this.listing.Address.PostCode}`;
  }

  get formattedDateAvailable(): string {
    if (!this.listing!.DateAvailable) return 'now';

    const now = new Date();
    const dateAvailable = new Date(this.listing!.DateAvailable);

    if (dateAvailable <= now) return 'now';

    return `${dateAvailable.getDate()}/${(dateAvailable.getMonth() + 1)}/${dateAvailable.getFullYear().toString().substr(2, 2)}`;
  }

  get virtualTour(): EmbeddedContent | null {
    if (this.listing === null) return null;

    const tour = this.listing.EmbeddedContent.find((content) => content.Type === EmbeddedContentType.VirtualTour);

    return tour || null;
  }

  get sellingAgents(): string {
    if (this.isCurrent || this.listing === null) return '';

    if (this.listing.Agents.length === 1) return this.listing.Agents[0].FullName;

    const agents = [...this.listing.Agents];

    const last = agents.pop();

    return `${agents.map((a) => a.FullName).join(', ')} & ${last?.FullName}`;
  }

  pluralise(number: number, singular: string, plural?: string): string {
    // eslint-disable-next-line no-nested-ternary
    return `${number} ${(number === 1 ? singular : plural == null ? `${singular}s` : plural)}`;
  }

  public head(): RouteMeta {
    return {
      title: this.listing!.Address.DisplayAddress ? this.listing!.Address.MicroAddress : this.listing!.Header,
      description: this.listing!.Introduction,
      image: this.listing!.Images.length ? this.listing!.Images[0].Preview.Url : undefined,
    };
  }

  public getAnalyticsData(): AnalyticsEventObject | null {
    if (this.listing === null) return null;

    return AnalyticsEventObject.FromListing(this.listing);
  }

  handleVideoViewed() {
    this.triggerCustomAnalyticsEvent(new AnalyticsEvent(AnalyticsEventType.ListingVideoViewed, AnalyticsEventObject.FromListing(this.listing!)));
  }

  handleContactFormSubmitted() {
    this.triggerCustomAnalyticsEvent(new AnalyticsEvent(AnalyticsEventType.ContactFormSubmit, AnalyticsEventObject.FromListing(this.listing!)));
  }

  handleIREClicked() {
    API.Listings.GetInspectRealEstateData(this.listing!.Id).then((ireData) => {
      window.open(ireData.Url, '_blank');
    }).catch(() => {
      // eslint-disable-next-line no-alert
      alert('There was an error processing your request. Please try again later.');
    });
  }
}
